import { DateTime } from 'luxon';
import { CurrencyCode } from '../config/CurrencyCode';
import { DailyExchangeRates, ExchangeRates } from '../data/models/ExchangeRates';
import { ExchangeRate } from '../data/models/ExchangeRate';

export const formatNumber = (value: number, currency: string, narrow: boolean = false): string => {
  const opts: Intl.NumberFormatOptions = { style: 'currency', currency };
  if (narrow) opts.currencyDisplay = 'narrowSymbol'; 

  const valueString = Math.abs(value).toLocaleString('en-GB', opts);
  
  if (value < 0) {
    return `(${valueString})`;
  }
  return valueString;
};

export const formatPercent = (value: number): string => {
  return value.toLocaleString('en-GB', { style: 'percent', maximumFractionDigits: 2 });
};

export const currencySymbol = (currency: CurrencyCode) => formatNumber(0, currency).replace(/\d|\./g, '').trim();

export const getExchangeRate = (from: CurrencyCode, to: CurrencyCode, exchangeRates: DailyExchangeRates): ExchangeRate => {
  if (from === to || !from || !to) return ExchangeRate.one(from);
  try {
    return exchangeRates.rates.get(from).get(to);
  } catch (e) {
    console.log(`Error reading conversion rate ${from}-${to}`);
    return ExchangeRate.one(from);
  }
};

export const getConversionRate = (from: CurrencyCode, to: CurrencyCode, exchangeRates: DailyExchangeRates): number => {
  return getExchangeRate(from, to, exchangeRates).rate;
};

export const convertCurrency = (value: number, from: CurrencyCode, to: CurrencyCode, exchangeRates: DailyExchangeRates) => {
  return value * getConversionRate(from, to, exchangeRates);
};

export const convertCurrencyAtDate = (value: number, from: CurrencyCode, to: CurrencyCode, date: DateTime, exchangeRates: ExchangeRates): number => {
  const rates = exchangeRates.atDate(date);
  return rates ? value * getConversionRate(from, to, rates) : value;
};

export const invoiceNumber = (id: number) => {
  return `${id}`.padStart(4, '0');
};

export const to6SigFigs = (amount: number) => {
  return parseFloat(amount.toPrecision(6));
};
